import { render, staticRenderFns } from "./employment.vue?vue&type=template&id=1f5b5685&"
import script from "./employment.vue?vue&type=script&lang=js&"
export * from "./employment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports